import { FaMobileAlt, FaCode, FaCloud } from 'react-icons/fa';
// import JungleContent1 from '../assets/images/JungleContent1.png';
// import BBC from '../assets/images/BBC.png';

export const contactInfo = {
  email: 'awais.ah514@gmail.com',
  phone: '+44 7879 733187',
  address: '3 chilworth place, barking, IG110FL,UK',
};
export const mobilenumber = {

  phone: '+447879733187',
}

export const navItems = [
  { label: "Business Overview", to: "/busniess-overview" },
  { label: "My Expertise", to: "/my-expertise" },
  { label: "Case Studies", to: "/case-studies" },
  // {
  //   label: "Hire Developers",
  //   isDropdown: true,
  //   dropdownColumns: [
  //     {
  //       columnLabel: "Front-End Developers",
  //       items: [
  //         {
  //           label: "React.js Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in React.js Developer position. Could you please provide more information? Thank you!",
  //         },
  //         {
  //           label: "Vue.js Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in Vue.js.js Developer position. Could you please provide more information? Thank you!",
  //         },
  //       ],
  //     },
  //     {
  //       columnLabel: "Back-End Developers",
  //       items: [
  //         {
  //           label: "Node.js Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in Node.js Developer position. Could you please provide more information? Thank you!",
  //         },
  //       ],
  //     },
  //     {
  //       columnLabel: "Mobile Developers",
  //       items: [
  //         {
  //           label: "React Native Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in React Native Developer position. Could you please provide more information? Thank you!",
  //         },
  //       ],
  //     },
  //     {
  //       columnLabel: "Full Stack Developers",
  //       items: [
  //         {
  //           label: "Mern Stack Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in Mern Stack Developer position. Could you please provide more information? Thank you!",
  //         },
  //         {
  //           label: "Full Stack Developer",
  //           phoneNumber: mobilenumber.phone,
  //           message: "Hi! I'm interested in Full Stack Developer position. Could you please provide more information? Thank you!",
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export const categories = ['Frontend', 'Backend', 'Databases', 'Cloud', 'DevOps'];
export const technologies = [
  { name: 'Node.js', image: require('../assets/images/node (2).webp'), category: 'Backend' },
  { name: 'FireBase', image: require('../assets/images/firebase.webp'), category: 'Backend' },
  // { name: 'FireBase', image: require('../assets/images/firebase.webp'), category: 'Cloud' },
  { name: 'MySQL', image: require('../assets/images/sql1.webp'), category: 'Databases' },
  // { name: 'HTML', image: require('../assets/images/html.webp'), category: 'Frontend' },
  { name: 'Express.js', image: require('../assets/images/expresslogo1.webp'), category: 'Backend' },
  { name: 'MongoDB', image: require('../assets/images/mongo.webp'), category: 'Databases' },
  { name: 'FireBase', image: require('../assets/images/firebase.webp'), category: 'Databases' },
  { name: 'FireBase', image: require('../assets/images/supabase.webp'), category: 'Databases' },
  { name: 'Redis', image: require('../assets/images/redis.webp'), category: 'Cloud' },
  { name: 'Nest', image: require('../assets/images/nest1.webp'), category: 'Backend' },
  { name: 'Amazone', image: require('../assets/images/amazon.webp'), category: 'Databases' },
  { name: 'React', image: require('../assets/images/react.webp'), category: 'Frontend' },
  { name: 'NEXT', image: require('../assets/images/next.webp'), category: 'Frontend' },
  { name: 'NEXT', image: require('../assets/images/next.webp'), category: 'Backend' },
  // { name: 'CSS', image: require('../assets/images/css.webp'), category: 'Frontend' },
  { name: 'JavaScript', image: require('../assets/images/javascript.webp'), category: 'Frontend' },
  // { name: 'Boostrap', image: require('../assets/images/bostap.webp'), category: 'Frontend' },
  { name: 'Matrial UI', image: require('../assets/images/ui (2).webp'), category: 'Frontend' },
  { name: 'Tailwind', image: require('../assets/images/tailwind.webp'), category: 'Frontend' },
  { name: 'GoogleCloud', image: require('../assets/images/gcp.webp'), category: 'Cloud' },
  { name: 'Azure', image: require('../assets/images/azure.webp'), category: 'Cloud' },
  { name: 'AWS', image: require('../assets/images/aws.webp'), category: 'Cloud' },
  { name: 'Digital Ocean', image: require('../assets/images/ocean.webp'), category: 'Cloud' },
  { name: 'Git', image: require('../assets/images/git.webp'), category: 'DevOps' },
  { name: 'Git Lab', image: require('../assets/images/lab.webp'), category: 'DevOps' },
  { name: 'Gradle', image: require('../assets/images/gradle.webp'), category: 'DevOps' },
  { name: 'Docker', image: require('../assets/images/docker.webp'), category: 'DevOps' },
  { name: 'Stack', image: require('../assets/images/stack.webp'), category: 'DevOps' },

];
export const image = [
  { src: require('../assets/images/express.webp'), alt: 'express' },
  { src: require('../assets/images/verba.webp'), alt: 'verba' },
  { src: require('../assets/images/zimb.webp'), alt: 'zimb' },
  { src: require('../assets/images/dash.webp'), alt: 'dash' },
];

export const boxData = [
  {
    icon: <FaMobileAlt className="h-12 w-12 text-gray-600 group-hover:text-white transition-transform duration-300 ease-in-out" />,
    name: 'Mobile Apps',
    description: 'Creating mobile applications using React Native, Android, iOS, and hybrid technologies tailored to your unique requirements across all devices.',
  },
  {
    icon: <FaCode className="h-12 w-12 text-gray-600 group-hover:text-white transition-transform duration-300 ease-in-out" />,
    name: 'Web Development',
    description: 'I develop responsive and engaging websites with React, Next, and Angular to provide a smooth user experience.',
  },
  {
    icon: <FaCloud className="h-12 w-12 text-gray-600 group-hover:text-white transition-transform duration-300 ease-in-out" />,
    name: 'DevOps',
    description: 'Providing cloud computing and DevOps services to enhance your IT infrastructure and workflows. I implement scalable cloud solutions tailored to your needs.',
  },
]

export const projects = [

  {
    id: 13,
    title: 'Pivott-Digital Real Estate Managment Tool',
    image: require('../assets/images/pivott.png'),
    category: 'website',
    date: 'Feb 29, 2025',
    details: [
      { title: "Pivott is a product that has alot of functionalites which include transcations, calling feature using WebRtc, chating through talk.js.This product is totaly based on roles.like collaborater, seller, Buyer,Landoard.Each user role choose his own template design view according to his choice." },
    ],
    industry: 'Fintech',
    languages: ['React', 'Node.js', 'AWS Lambda', 'WebRTC', 'Redux'],
    time: '3 months'
  },
  {
    id: 12,
    title: 'UncleKam: Premier Tax Solutions Platform',
    image: require('../assets/images/unclekams.png'),
    category: 'website',
    date: 'Jan 10, 2025',
    details: [
      { title: "A premier tax solutions platform that provides financial clarity to our client's unique tax situations.To commit to delivering comprehensive tax solutions that keep our clients compliant and protect their hard-earned money, ensuring their financial well-being and peace of mind." },
    ],
    industry: 'Fintech',
    languages: ['MySQL', 'Node.js', 'Sequelize', 'MySQL', 'Amazon EC2'],
    time: '3 months'
  },
  {
    id: 11,
    title: 'SandStrip-Admin Panel For Havazuse App',
    image: require('../assets/images/sand.png'),
    category: 'website',
    date: 'Aug 29, 2024',
    details: [
      { title: "Admin Dashboard for his Havazuse app to manage catalogue of product's. Give Dynamic stats , manage refunds and trace revenue on monthly, daily, yearly bases" },
    ],
    industry: 'Fintech',
    languages: ['Next.js', 'Node.js', 'Sequelize', 'REST API', 'DigitalOcean'],
    time: '3 months'
  },
  {
    id: 0,
    title: 'Havazuse Android & IOS',
    image: require('../assets/images/havazuse.webp'),
    category: 'mobile-app',
    date: 'Feb 4, 2024',
    details: [
      { title: "Havazuse App is E-commerce app with some advance feature like Live Video Streaming, Video edit for making reels and post it into user account. For purchasing product integrated clearpay , Google Pay, Pay through Debit/Credit Card and Klarna.Using Redux Tolkit latest technology to handle store management" },
      {
        feature: [
          'React-Native drives the interface with unmatched flexibility for Android and iOS platforms.',
          'Node.js delivers lightning-fast performance for the backend, handling complex e-commerce transactions with ease.',
          'Havazuse empowers users with a smooth shopping experience, offering built-in payment methods and an integrated video-streaming platform to enhance product sales.'
        ]
      },
    ],
    industry: 'E-commerce',
    languages: ['React-Native', 'Redux', 'Node.js', 'Firebase', 'ExpressJS', 'CI/CD', 'My Sql Server'],
    time: '7 months'
  },
  {
    id: 14,
    title: 'Mealticket Diet Planner App – Android & iOS',
    image: require('../assets/images/mail.png'),
    category: 'mobile-app',
    date: 'jan 4, 2023',
    details: [
      { title: "A React Native mobile application designed to help users effortlessly plan and track their meals for the weekend. The app allows users to create personalized meal plans for Saturday and Sunday, covering breakfast, lunch, dinner, and snacks with the flexibility to save and edit plans.Key features include a built-in food database with nutritional values, enabling users to search predefined meals or add custom options. Additionally, the app generates a shopping list based on planned meals to ensure users have all necessary ingredients. Real-time nutritional tracking helps users monitor calorie intake and macronutrients while receiving reminders to stay on track.The app supports various dietary preferences, offers UI customization, and provides progress tracking for long-term consistency. Built with React Native, Firebase, and state management tools like Redux or Context API, it delivers a seamless and intuitive experience, keeping users committed to their dietary goals." },
      {
        feature: [
          'Powered by React-Native, offering a smooth, cross-platform user experience.',
          'Built on Node.js for a robust and AI-driven backend that scales effortlessly.',
          'Verba is a unique AI platform delivering virtual mental therapies and providing detailed therapy assessments for customers’ therapists.'
        ]
      },
    ],
    industry: 'AI/Social',
    languages: ['React Native', 'Firebase', ' Redux / Context API', 'Real-Time Nutritional Tracking', 'Meal Planning & Progress Tracking',],
    time: '2 months'
  },
  {
    id: 1,
    title: 'Verba AI Mental Health Tracker',
    image: require('../assets/images/verbabg.webp'),
    category: 'web-app',
    date: 'Dec 4, 2023',
    details: [
      { title: "Track your mental health to discuss in therapy Improve your mental health by tracking thoughts and moods with daily 2 minute chats. Verba is a mental health AI therapy tool that generates insights to enhance your therapy sessions and help manage anxiety between sessions." },
      {
        feature: [
          'Powered by React-Native, offering a smooth, cross-platform user experience.',
          'Built on Node.js for a robust and AI-driven backend that scales effortlessly.',
          'Verba is a unique AI platform delivering virtual mental therapies and providing detailed therapy assessments for customers’ therapists.'
        ]
      },
    ],
    industry: 'AI/Social',
    languages: ['React Native', ' NodeJS Framework', 'MongoDB', 'Android App Development', 'iOS Development'],
    time: '2 months'
  },
  {
    id: 9,
    title: 'TopRent Android & IOS Application',
    image: require('../assets/images/CM.webp'),
    category: 'mobile-app',
    date: 'Sep 7, 2023',
    details: [
      { title: "Toprent is a mobile application designed to streamline and optimise the reservation process for toprent's drivers, making their daily tasks more efficient and hassle-free.Seamless Reservation Assignment: As an admin or manager, you can effortlessly assign reservations to individual drivers through the app's intuitive interface.Check-In and Checkout: Drivers can easily check-in and checkout of their assigned reservations within the app" },
      {
        feature: [
          'Harnessing the power of React-Native for a seamless and intuitive user experience.',
          'Backed by the real-time capabilities of Firebase for a secure and efficient backend.',
          'Top Rent App lets users rent their cars as cabs to different drivers and manages the cars’ condition directly linked with insurance records and all previous history of lessees.'
        ]
      },
    ],
    industry: ' Transportation',
    languages: ['React', 'React Native', 'Node.js', 'Mobile App Development'],
    time: '5 months'
  },
  {
    id: 7,
    title: 'My Cabin Auto App – Transportation Management',
    image: require('../assets/images/cabinauto1.webp'),
    category: 'mobile-app',
    date: 'July 6, 2023',
    details: [
      { title: "A modern cab booking and management platform designed to enhance customer interactions and streamline operations. Built with React Native for a responsive cross-platform experience and Node.js for a scalable, high-performance backend. Firebase provides real-time data synchronization, while MongoDB ensures efficient and flexible data storage. Google Analytics enables user behavior tracking, optimizing engagement and performance." },
      {
        feature: [
          'Built with React to deliver a fast and dynamic user interface.',
          'Powered by the versatility of Node.js for a scalable, high-performance backend.',
          'My Cabin Auto App enhances customer interaction with a refined web experience, providing seamless cab booking and management solutions.'
        ]
      },
    ],
    industry: 'Transportation',
    languages: ['React Native', 'JavaScript', 'Firebase', 'monogodatabase', ' Google Analytics'],
    time: '3 months'
  },
  {
    id: 2,
    title: 'IoT Device Control App – Android & iOS',
    image: require('../assets/images/express.webp'),
    category: 'mobile-app',
    date: 'Nov 3, 2022',
    details: [
      { title: "An advanced IoT-based mobile app designed for seamless device control. Built with **React Native** for an intuitive cross-platform UI and **Node.js** for real-time backend communication. **Bluetooth integration** enables secure connectivity, allowing users to manage electronic devices effortlessly. **Express Energie** facilitates remote device control and monitoring, ensuring a smooth automation experience." },
    ],
    industry: 'IoT',
    languages: ['React Native', 'JavaScript', 'Tuya Api Integration', 'Bluetooth Integration', 'IoT Device Management', 'Express.js'],
    time: '5 months'
  },

  {
    id: 3,
    title: 'Chorelito Android & IOS Mobile App',
    image: require('../assets/images/t.webp'),
    category: 'mobile-app',
    date: 'Sep 2, 2022',
    details: [
      { title: "Chorelito app allows users to connect, communicate, and share moments through real-time messaging. Whether for personal conversations, group discussions, or business communication, the app offers seamless, secure, and intuitive interactions.Skills and deliverables" },
      {
        feature: [
          'Crafted with React-Native to deliver real-time social interaction and communication.',
          'Firebase brings powerful real-time data handling to the backend, keeping users connected.',
          'Chorelito enables users to connect through chat, audio/video calls, and sharing moments with loved ones via photos and videos.'
        ]
      },
    ],
    industry: 'Social',
    languages: ['React Native', 'Supabase', 'Firebase', 'Redux', 'Supabase',],
    time: '8 months'
  },
  {
    id: 4,
    title: 'Virtual Robot Simulator – Web Application',
    image: require('../assets/images/project5.webp'),
    category: 'web-app',

    date: 'July 6, 2021',
    details: [
      { title: "A cutting-edge web application designed to provide students with a virtual environment to design, program, and test robots. Developed with **React** for a highly interactive and engaging frontend, ensuring smooth user interactions. **Node.js** powers the backend, enabling seamless integration and efficient real-time simulation processing. Built with **TypeScript** and **JavaScript** to enhance maintainability and scalability, this simulator revolutionizes learning experiences in robotics and automation." },
      {
        feature: [
          'Developed with React, delivering a highly interactive and engaging frontend.',
          'Node.js supercharges the backend, offering seamless integration and efficient performance for real-time simulations.',
          'The Virtual Robot Simulator allows students to design, program, and test robots in a virtual environment, creating a revolutionary learning experience.'
        ]
      },
    ],
    industry: 'Fintech',
    languages: ['React', 'TypeScript', 'JavaScript', 'NodeJS', 'Real-Time Simulation '],
    time: '3 months'
  },
  {
    id: 5,
    title: 'One Stop Zimb Android & IOS',
    image: require('../assets/images/zimb.webp'),
    category: 'mobile-app',
    date: 'Mar 12, 2021',
    details: [
      { title: "A comprehensive online directory designed to connect businesses with customers actively seeking products and services. Built with **React Native** to deliver a seamless, immersive, and responsive experience across Android and iOS platforms. **Node.js** powers the backend, ensuring swift and reliable performance for business listings and user interactions. **TypeScript** and **JavaScript** enhance code maintainability and scalability, making the platform efficient and future-proof." },
      {
        feature: [
          'Built using React to offer an immersive, responsive user experience on all platforms.',
          'Node.js powers the backend, ensuring swift and reliable performance for business listings and interactions.',
          'One Stop Zimb is a comprehensive online directory, helping businesses reach customers actively seeking to make purchases.'
        ]
      },
    ],
    industry: 'Fintech',
    languages: ['React Native', 'TypeScript', 'JavaScript', 'Node.js', 'Business Listing Management '],
    time: '3 months'
  },
  {
    id: 6,
    title: 'URCP – Trip Booking Web App',
    image: require('../assets/images/urpc.webp'),
    category: 'web-app',
    date: 'Aug 9, 2020',
    details: [
      { title: "A modern web application designed to simplify trip booking through various advisors and agencies. Built with **React.js** for a responsive and intuitive user experience, ensuring smooth navigation and interactivity. **Firebase** powers the backend, enabling real-time data processing and efficient trip scheduling. Secure **online payment integration** enhances the booking process, providing users with a seamless and reliable experience." },
    ],
    industry: 'Trip Booking',
    languages: ['React.js', 'JavaScript', 'Firebase', 'Real-Time Data Processing', 'Online Payment Integration '],
    time: '3 months'
  },
  {
    id: 8,
    title: 'My True Liberia App – Web & Mobile',
    image: require('../assets/images/project1.webp'),
    category: 'web-app',
    date: 'July 6, 2019',
    details: [
      { title: "A modern and engaging platform designed to provide users with a seamless digital experience. Developed with **React Native** for a sleek and responsive frontend across web and mobile platforms. **Node.js** ensures robust backend performance and efficient data handling, while **Firebase** enables real-time synchronization and authentication. Built with **TypeScript** and **JavaScript**, the app offers scalability, maintainability, and a smooth user experience. " },
      {
        feature: [
          'Powered by React for a sleek, modern frontend experience.',
          'Node.js fuels the backend with robust performance and efficient data handling.',
          'My True Liberia App offers a seamless and engaging platform for users, utilizing state-of-the-art web technologies.'
        ]
      },
    ],
    industry: 'Fintech',
    languages: ['React Native', 'TypeScript', 'JavaScript', 'Firebase', 'Node.js'],
    time: '3 months'
  },
  {
    id: 10,
    title: 'My Lost & Found App – Web & Mobile',
    image: require('../assets/images/project4.webp'),
    category: 'web-app',
    date: 'May 6, 2019',
    details: [
      { title: "A modern and intuitive platform designed to help users track and recover lost belongings through efficient data management and community engagement. Developed with React Native for a seamless and interactive user experience across web and mobile. Node.js powers the backend, ensuring secure, real-time data handling, while TypeScript and JavaScript enhance code scalability and maintainability." },
      {
        feature: [
          'Built with React for a highly intuitive and interactive user interface.',
          'Node.js drives the backend, ensuring secure, real-time data handling for lost and found items.',
          'My Lost & Found App helps users find misplaced belongings through efficient data tracking and community engagement.'
        ]
      },
    ],
    industry: 'Fintech',
    languages: ['TypeScript', 'JavaScript', 'Node.js', 'Real-Time Data Processing',      'DevOps'],
    time: '3 months'
  },

  {
    id: 23,
    title: 'OptiSlot – Appointment & Booking SaaS',
    image: require('../assets/images/optislot-dashboard-mockup.png'),
    category: 'web-app',
    date: 'Aug 20, 2026',

    details: [
      {
        title:
          "OptiSlot is a modern Appointment & Booking SaaS platform designed to help businesses manage appointments, customers, services, staff, calendars and payments from one centralized platform. The responsive interface provides a seamless experience across desktop, tablet and mobile devices, making it easy for businesses and customers to manage bookings anytime."
      },

      {
        feature: [
          'Appointment and booking management with an interactive calendar for managing schedules and available time slots.',

          'Customer management allows businesses to view and organize customer information, appointments and booking history.',

          'Service management enables businesses to create services, define duration and pricing, and manage available staff.',

          'Responsive dashboard provides an overview of appointments, customers, revenue and recent booking activity.',

          'Online booking interface allows customers to select a service, staff member, date and available time slot.',

          'Payment and revenue management helps businesses keep track of payments and booking-related revenue.',

          'Fully responsive UI provides an optimized experience across desktop, laptop, tablet and mobile devices.'
        ]
      }
    ],

    industry: 'SaaS / Appointment & Booking',

    languages: [
      'React.js',
      'Node.js',
      'Express.js',
      'MongoDB',
      'GitLab',
      'Tailwind CSS',
      'REST API'
    ],

    time: '4 months'
  },
  {
    id: 24,
    title: 'NeuraFlow AI – All-in-One AI SaaS Platform',
    image: require('../assets/images/Al.png'),
    category: 'web-app',
    date: 'Jan 20, 2026',

    details: [
      {
        title:
          "NeuraFlow AI is an all-in-one AI SaaS platform designed to help individuals and teams create content, analyze data, generate images, summarize documents, write emails, build presentations, and manage AI-powered projects from one centralized platform. The responsive interface provides a consistent experience across desktop and mobile devices."
      },

      {
        feature: [
          'AI Assistant helps users generate content, answer questions, summarize documents, and complete everyday tasks with AI.',

          'AI Content Writer enables users to create blog posts, social media content, emails, presentations, and other professional content.',

          'AI Image Generator allows users to generate creative visuals and images using AI-powered tools.',

          'AI Document Analyzer helps users summarize and analyze documents to quickly extract important information.',

          'AI Data Analysis provides insights from business data through analytics, reports, and visual dashboards.',

          'Project Management allows users to organize AI-powered projects, tasks, documents, and recent activities in one place.',

          'Team Collaboration enables multiple team members to work together and track project activity.',

          'Responsive design delivers a seamless experience across desktop, tablet, and mobile devices.'
        ]
      }
    ],

    industry: 'Artificial Intelligence / SaaS',

    languages: [
      'React',
      'JavaScript',
      'Tailwind CSS',
      'Node.js',
      'Cloud',
      'Express.js',
      'MongoDB',
      'OpenAI API',
      'REST API'
    ],

    time: '5 months'
  },
 
  // {
  //   id: 25,
  //   title: 'Pivott-Digital Real Estate Managment Tool',
  //   image: require('../assets/images/pivvot.png'),
  //   category: 'website',
  //   date: 'Feb 29, 2025',
  //   details: [
  //     { title: "Pivott is a product that has alot of functionalites which include transcations, calling feature using WebRtc, chating through talk.js.This product is totaly based on roles.like collaborater, seller, Buyer,Landoard.Each user role choose his own template design view according to his choice." },
  //   ],
  //   industry: 'Fintech',
  //   languages: ['React', 'Node.js', 'AWS Lambda', 'WebRTC', 'Redux'],
  //   time: '3 months'
  // },
  {
    id: 26,
    title: 'AmplifiSaaS – Marketing Intelligence Platform',
    image: require('../assets/images/Marketing social media saas.png'),
    category: 'website',
    date: 'May 04, 2023',
    details: [
      {
        title: "AmplifiSaaS is a comprehensive marketing intelligence platform that enables businesses to monitor campaign performance, analyze customer engagement, track conversions, and generate actionable insights through an intuitive analytics dashboard."
      },
      {
        feature: [
          'Advanced campaign performance tracking and reporting.',
          'Real-time audience engagement and conversion analytics.',
          'Interactive dashboards with visual charts and growth metrics.',
          'Campaign reach, click-rate, and ROI monitoring.',
          'Marketing report generation and performance comparison.',
          'Business intelligence tools for data-driven decision making.',
          'Secure user management and campaign administration.',
          'Modern responsive dashboard optimized for all screen sizes.'
        ]
      }
    ],
    industry: 'Digital Marketing',
    languages: [
      'React.js',
      'Redux Toolkit',
      'Node.js',
      'Express.js',
      'MongoDB',
      'Chart.js',
      'REST API'
    ],
    time: '3 months'
  },
   {
    id: 27,
    title: 'CortexHub – AI Productivity App',
    image: require('../assets/images/AI saas product.png'),
    category: 'mobile-app',
    date: 'Dec 3, 2025',
    details: [
      {
        title: "CortexHub AI is an all-in-one AI-powered mobile application that brings multiple intelligent tools into one platform. The app helps users generate content, create images, interact with an AI chatbot, build resumes, analyze documents, and translate text through a simple and engaging mobile experience."
      },
      {
        feature: [
          'AI Writer helps users create blogs, emails, social media posts, advertisements, and other professional content.',
          'AI Chatbot provides smart assistance for questions, ideas, research, and everyday tasks.',
          'AI Image Generator creates unique images from user prompts with multiple creative styles.',
          'AI Resume Builder helps users create professional resumes quickly and easily.',
          'AI Document Analyzer analyzes documents and extracts important information.',
          'AI Translator allows users to translate text into different languages.',
          'Responsive and user-friendly mobile interface designed for a smooth experience on Android and iOS devices.'
        ]
      }
    ],
    industry: 'Artificial Intelligence',
    languages: ['React Native',
      'Redux',
      'Node.js',
      'Firebase',
      'ExpressJS',
      'CI/CD',
      'My Sql Server'],
    time: '5 months'
  },
    {
  id: 28,
  title: 'FRANTZMASTER – Global Battles & Gaming Platform',
  image: require('../assets/images/frantzmaster.png'),
  category: 'mobile-app',
  date: 'Feb 20, 2026',

  details: [
    {
      title:
        "FRANTZMASTER is a modern global gaming and social battle platform designed to connect players through competitive battles, player profiles, virtual coins and community interactions. The platform provides an engaging mobile experience where users can create accounts, discover players, manage their profiles, follow other users and manage virtual coins from a centralized wallet and store."
    },

    {
      feature: [
        'User authentication with account registration, secure login and guest access for a smooth onboarding experience.',

        'Player profile management allows users to update their username, country, profile picture and avatar.',

        'Global player discovery enables users to search and explore players from different countries.',

        'Following and social connection features allow players to follow other users and build their gaming community.',

        'Player profiles display important gaming information including level, battles, wins, streaks and virtual coin balance.',

        'Virtual Coin Vault allows players to view their available coins and manage their virtual currency.',

        'Coin Store provides different virtual coin packages that users can select and add to their wallet.',

        'Virtual gifting and supporter features allow users to support other players and participate in community interactions.',

        'Profile editing provides options for selecting preset avatars, uploading profile photos and updating personal information.',

        'Mobile-first responsive interface provides a smooth gaming experience across different mobile screen sizes.'
      ]
    }
  ],

  industry: 'Gaming / Social Networking / Virtual Rewards',

  languages: [
    'React Native',
    'Node.js',
    'Express.js',
    'MongoDB',
    'REST API',
    'Firebase Authentication',
    'Google OAuth',
    'Socket.io',
    'GitLab'
  ],

  time: '4 months'
  }
];

export const CaseStudies = [
  {
    id: 1,
    bgColor: "#F3EFFC",
    imgSrc: require("../assets/images/pivott_no_bg.png"),
    title: "Pivott-Digital Real Estate Managment Tool",
    description: "Pivott is a product that has alot of functionalites which include transcations, calling feature using WebRtc, chating through talk.js.This product is totaly based on roles.like collaborater, seller, Buyer,Landoard.Each user role choose his own template design view according to his choice.",
    textColor: "text-primary",
  },
  {
    id: 2,
    bgColor: "#FFEEE2",
    imgSrc: require("../assets/images/europe.png"),
    title: "JOSEPHA - Price Comparison & Fake Shop Detector",
    description: "JOSEPHA is a product that has a lot of functionalities which include instant price comparison, fake shop detection, browser extension support. This product works by simply putting JOSEPHA.de/ before any product URL or sharing the page directly with the app. Results appear within seconds — faster than Idealo or Check24, with zero ads.",
    textColor: "text-primary",
  },
  {
    id: 3,
    bgColor: "#c8e0ba",
    imgSrc: require("../assets/images/verbabg.webp"),
      title: "Verba AI Mental Health Tracker",
      description: "Track your mental health to discuss in therapy Improve your mental health by tracking thoughts and moods with daily 2 minute chats. Verba is a mental health AI therapy tool that generates insights to enhance your therapy sessions and help manage anxiety between sessions.",
    textColor: "text-primary",
  }
];


export const timelineItems = [
  {
    number: 1,
    title: "Assemble the right team",
    description: "We handle all aspects of vetting and choosing the right team that you don't have the time, expertise, or desire to do."
  },
  {
    number: 2,
    title: "Sprint planning",
    description: "Sprint roadmap is a collective planning effort. Team members collaborate to clarify items and ensure shared understanding."
  },
  {
    number: 3,
    title: "Tech architecture",
    description: "We break monolithic apps into microservices. Decoupling the code allows teams to move faster."
  },
  {
    number: 4,
    title: "Standups & weekly demos",
    description: "Standups, weekly demos, and weekly reviews ensure everyone is on the same page and can raise concerns."
  },
  {
    number: 5,
    title: "Code reviews",
    description: "Code reviews before release help detect issues like memory leaks, file leaks, performance signs."
  },
  // {
  //   number: 6,
  //   title: "Iterative delivery",
  //   description: "We divide the implementation process into several checkpoints rather than a single deadline."
  // }
];
export const cardData = [
  {
    title: "I craft emotional connections, not just visuals and copy.",
    description: "I look beyond mere pixels and text to uncover the essence of what moves people. I grasp the heartbeat of human emotions and craft narratives that touch souls. My designs don't just adorn screens, they imprint on minds. Because at the core of every lasting brand is a genuine connection that transforms casual encounters into steadfast loyalty.",
    highlight: "emotional connections",
    color: "blue-500",
  },
  {
    title: "I don't just design, I unleash creative firestorms.",
    description: "Sick of same-old marketing and cookie-cutter websites? I'm not just here to tick boxes—I’m here to set your brand ablaze with audacious ideas and razor-sharp strategy. My campaigns don’t just turn heads, they turn the ordinary into the extraordinary. I’m here to launch entire constellations.",
    highlight: "unleash creative",
    color: "blue-500",
  },
  {
    title: "I fuel creativity with data, guide passion with precision.",
    description: "I’m more than a creative dreamer, I’m a strategic sorcerer. Merging data’s precision with unfiltered passion, I conjure campaigns that captivate, connect, and convert. Because raw enthusiasm alone is a dazzling mess without the right spell to guide it.",
    highlight: " creativity",
    color: "blue-500",
  },
  {
    title: "I don't just work with you, I become your creative champion.",
    description: "I don’t just partner with clients; I co-create with allies. Your vision becomes my blueprint, and your success is my shared triumph. I weave your aspirations into my creative fabric, transforming dreams into tangible brilliance—together, as one unstoppable force.",
    highlight: "creative champion",
    color: "blue-500",
  },
];

// src/constants/powerCardData.js

export const powerCards = [
  {
    number: "01",
    title: "Creativity.",
    description: "I dare to dream big and push boundaries, refusing to settle for the ordinary.",
    direction: "left",
    delay: 0,
  },
  {
    number: "02",
    title: "Collaboration.",
    description: "I flourish on a spectrum of viewpoints and revel in the alchemy of collective creativity.",
    direction: "right",
    delay: 1,
  },
  {
    number: "04",
    title: "Innovation.",
    description: "I’m fueled by a passion to make an impact, crafting brands that move mountains and reshape horizons.",
    direction: "left",
    delay: 3,
  },
  {
    number: "03",
    title: "Impact.",
    description: "I stay ahead of the curve, harnessing cutting-edge technologies to keep your brand at the forefront.",
    direction: "right",
    delay: 2,
  },
];


export const testimonials = [
  {
    text: `"Awais Ahmad is the best app developer for our project. His suggestions and feedback are very helpful. Thanks for the timely delivery."`,
    author: "Jignesh",
    position: "HR of Express Energy",
  },
  {
    text: `"Great Figma to React app conversion with animation. Totally satisfied! Will work again with Awais Ahmad."`,
    author: "Emili",
    position: "Manager of Cabin Auto",
  },
  {
    text: `"Awais Ahmad is wonderful to work with. His front-end development work goes beyond expectations. I look forward to working with him on my future projects."`,
    author: "Jonathan Weiland",
    position: "Senior Developer of Virtual Robot Simulator",
  },
  {
    text: `"I hired Awais Ahmad for full-stack app development. He has helped create a great app."`,
    author: "Advait",
    position: "CEO of VERBA",
  },
  {
    text: `"Very good developer and easy to work with. Very quick to respond and proactive in the development process."`,
    author: "Dvldog",
    position: "CTO at Chorelito",
  },
];

export const sliderData = [
  {
    id: 1,
    image: require('../assets/images/awais1.webp'),
    name: 'Awais Ahmad',
    type: 'Founder & C.E.O',
    location: 'London, UK',
    phoneNumber: "+447879733187"
  },
  {
    id: 5,
    image: require('../assets/images/AzmeerRaza.webp'),
    name: 'Azmeer Raza',
    type: 'C.O.O',
    location: 'Multan,PK',
    phoneNumber: "+447879733187"
  },
  {
    id: 4,
    image: require('../assets/images/ShameerRaza.webp'),
    name: 'Shameer Raza',
    type: 'C.T.O',
    location: 'Multan,PK',
    phoneNumber: "+447879733187"
  },
  {
    id: 2,
    image: require('../assets/images/waqar2.webp'),
    name: 'Waqar Ahmad',
    type: 'HR Manager',
    location: 'Faisalabad,PK',
    phoneNumber: "+923081811079"

  },
  {
    id: 3,
    image: require('../assets/images/hassan.webp'),
    name: 'Hassan Shahid',
    type: 'Project Manager',
    location: 'Faisalabad,PK',
    phoneNumber: "+923047267072"
  }

];

export const boxDataDesktop = [
  {
    x: 50,
    y: 80,
    color: "purple",
    number: 1,
    title: "Ideation",
    delay: "0.5s",
    className: "hidden md:block",
    description: "Turn your groundbreaking idea into a software powerhouse—fuel innovation and lead the future of digital disruption."
  },
  {
    x: 750,
    y: 250,
    color: "blue",
    number: 2,
    title: "UI Design",
    delay: "1.5s",
    className: "hidden md:block",
    description: "Create stunning UI designs that captivate at first glance—transforming user journeys into unforgettable experiences."
  },
  {
    x: 50,
    y: 450,
    color: "green",
    number: 3,
    title: "Frontend",
    delay: "2s",
    className: "hidden md:block",
    description: "Elevate user experiences with cutting-edge frontend design—crafted to dazzle, perform, and drive engagement."
  },
  {
    x: 750,
    y: 630,
    color: "orange",
    number: 4,
    title: "Backend",
    delay: "3s",
    className: "hidden md:block",
    description: "Unleash the full potential of your software with a backend engineered for unmatched speed, scalability, and security."
  },
  {
    x: 50,
    y: 820,
    color: "red",
    number: 5,
    title: "Deployment",
    delay: "4s",
    className: "hidden md:block",
    description: "Take your product live with seamless, zero-downtime deployment—ensuring your software’s success from day one."
  },
  {
    x: 750,
    y: 990,
    color: "pink",
    number: 6,
    title: "Maintenance",
    delay: "6s",
    className: "hidden md:block",
    description: "Stay ahead with proactive maintenance—keeping your software flawless, future-ready, and unstoppable in any environment."
  },
];

export const boxDataMobile = [
  {
    x: 50,
    y: 80,
    color: "purple",
    number: 1,
    title: "Ideation",
    delay: "0.5s",
    className: "md:hidden",
    description: "Turn your groundbreaking idea into a software powerhouse—fuel innovation and lead the future of digital disruption.",
    icon: "IdeationIcon"
  },
  {
    x: 50,
    y: 630,
    color: "blue",
    number: 2,
    title: "UI Design",
    delay: "2s",
    className: "md:hidden",
    description: "Create stunning UI designs that captivate at first glance—transforming user journeys into unforgettable experiences.",
    icon: "UIDesignIcon"
  },
  {
    x: 50,
    y: 1190,
    color: "green",
    number: 3,
    title: "Frontend",
    delay: "3s",
    className: "md:hidden",
    description: "Elevate user experiences with cutting-edge frontend design—crafted to dazzle, perform, and drive engagement.",
    icon: "FrontendIcon"
  },
  {
    x: 50,
    y: 1750,
    color: "orange",
    number: 4,
    title: "Backend",
    delay: "4s",
    className: "md:hidden",
    description: "Unleash the full potential of your software with a backend engineered for unmatched speed, scalability, and security.",
    icon: "BackendIcon"
  },
  {
    x: 50,
    y: 2310,
    color: "red",
    number: 5,
    title: "Deployment",
    delay: "5s",
    className: "md:hidden",
    description: "Take your product live with seamless, zero-downtime deployment—ensuring your software’s success from day one.",
    icon: "DeploymentIcon"
  },
  {
    x: 50,
    y: 2870,
    color: "pink",
    number: 6,
    title: "Maintenance",
    delay: "6s",
    className: "md:hidden",
    description: "Stay ahead with proactive maintenance—keeping your software flawless, future-ready, and unstoppable in any environment.",
    icon: "MaintenanceIcon"
  },
];



